import { supabase_guest } from "../supabase/supabaseClient";

export const fetchEventDetail = async (eventId) => {
  const { data, error } = await supabase_guest
    .from("event")
    .select("*")
    .eq("id", eventId)
    .maybeSingle();

  if (error) {
    console.error("EVENT DETAIL ERROR:", {
      eventId,
      message: error.message,
      details: error.details,
      hint: error.hint,
      code: error.code,
    });
    return null;
  }

  if (!data) {
    console.warn("EVENT DETAIL NOT FOUND OR BLOCKED BY RLS:", { eventId });
    return null;
  }

  return data;
};

export const fetchEventRundown = async (eventId) => {
  const { data, error } = await supabase_guest
    .from("event_rundown")
    .select(`
      id,
      start_time,
      end_time,
      schedule_name,
      schedule_description
    `)
    .eq("event_id", eventId)
    .order("start_time", { ascending: true });

  if (error) {
    console.error("fetchEventRundown error:", error);
    return [];
  }

  return data;
};

export const fetchEventPackages = async (eventId) => {
  const { data, error } = await supabase_guest
    .from("event_dana")
    .select(`
      id,
      package_name,
      package_detail,
      price,
      quantity,
      curr_quantity,
      robe_qty,
      sequence,
      is_sponsor
    `)
    .eq("event_id", eventId)
    .order("sequence", { ascending: true });

  if (error) {
    console.error("fetchEventPackages error:", error);
    return [];
  }

  return data;
};
